// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CollectionRouteImport } from './routes/collection'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as PersonalizationRouteImport } from './routes/personalization'
import { Route as StudioRouteImport } from './routes/studio'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const CollectionRoute = CollectionRouteImport.update({
            id: '/collection',path: '/collection',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const PersonalizationRoute = PersonalizationRouteImport.update({
            id: '/personalization',path: '/personalization',getParentRoute: () => rootRouteImport
          })
const StudioRoute = StudioRouteImport.update({
            id: '/studio',path: '/studio',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,CollectionRoute: CollectionRoute,ContactRoute: ContactRoute,PersonalizationRoute: PersonalizationRoute,StudioRoute: StudioRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)